<div class="c-box">
  <ion-header>
    <ion-toolbar>
      <!-- <ion-title></ion-title> -->
      <ion-button (click)="dismissModal()" slot="end" fill="clear">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-toolbar>
  </ion-header>

  <div class="c-box-1">
    <ng-container *ngFor="let fieldOrLabel of champs">
      <ion-row>
        <ion-col size="12" class="ion-no-padding">
          <app-c-all-fields
            [modeShow]="modeShow"
            [forms]="forms"
            [blocName]="blocName"
            [fieldOrLabel]="fieldOrLabel"
            [display]="display"
            [context]="'preparation'"
            [observeSourcesArrFromParentPage]="observeSourcesArr"
            [step]="step"
            [bloc]="bloc"
            [mainFormOrSubForm]="'sub-form'"
          ></app-c-all-fields>
          <!-- TODO-pf? réintégrer si pertinent (triggerAlert)="cascadeTriggerAlert($event)" -->
          <!-- TODO-pf? réintégrer si pertinent (fieldSketchFormArraySubGroupEditor)="displayFormArraySubGroupEditor($event)" -->
        </ion-col>
      </ion-row>
    </ng-container>
  </div>
</div>